import crypto from 'crypto';

export const uuidV4Regex = /[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}/gi;
const onlyUUIDV4Regex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
const isValidUUID = (uuid: string) => {
  if (!uuid) {
    return false;
  }
  return onlyUUIDV4Regex.test(uuid);
};

const mapUUIDToBucket = (uuid: string, numBuckets = 10) => {
  const hashedNumber = crypto.createHash('sha256').update(uuid).digest('hex');

  return (parseInt(hashedNumber, 16) % numBuckets) + 1;
};

export { isValidUUID, mapUUIDToBucket };
